import React from 'react';
// import { Menu } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import MenuNavLink from './components/MenuNavLink';
import { Link, useHistory } from 'react-router-dom';
import RouteEnum from '../../../constants/RouteEnum';
import styles from './MainNav.module.scss';
import Label from '../../../constants/Label';
import homeImg from './icons/home.svg';
import ratesImg from './icons/rates.svg';
import newsImg from './icons/news.svg';
import transfersImg from './icons/transfer.svg';
import branchesImg from './icons/branches.svg';
import calculatorImg from './icons/currency.svg';
import moreImg from './icons/more.svg';
import beneficiaryImg from './icons/beneficiaries.svg';
import mytransferImg from './icons/mytransfer.svg';
import logout from 'assets/images/logout.svg';

const MainNav = () => {
  const history = useHistory();
  const logoutPage = () => {
    localStorage.clear();
    history.push('/');
  };
  return (
    <div className={styles.mainContainer__navigation}>
      <div className={styles.mainContainer__navTop}>
        <NavLink as={MenuNavLink} to={RouteEnum.Home} name="Home" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={homeImg} alt="" />
            {Label.Mainnav.home}
          </span>
        </NavLink>
        <NavLink as={MenuNavLink} to={RouteEnum.Rates} name="Rates" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={ratesImg} alt="" />
            {Label.Mainnav.Rates}
          </span>
        </NavLink>
        <NavLink as={MenuNavLink} to={RouteEnum.Transfer} name="Transfer" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={transfersImg} alt="" />
            {Label.Mainnav.Transfer}
          </span>
        </NavLink>
      </div>
      <div className={styles.mainContainer__navBottom}>
        <NavLink as={MenuNavLink} to={RouteEnum.Calculator} name="Calculator" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={calculatorImg} alt="" />
            {Label.Mainnav.CurrencyCalculator}
          </span>
        </NavLink>
        <NavLink as={MenuNavLink} to={RouteEnum.Beneficiary} name="Beneficiary" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={beneficiaryImg} alt="" />
            {Label.Mainnav.MyBeneficiaries}
          </span>
        </NavLink>
        <NavLink as={MenuNavLink} to={RouteEnum.Mytransfer} name="Mytransfer" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={mytransferImg} alt="" />
            {Label.Mainnav.MyTransfer}
          </span>
        </NavLink>
        <NavLink as={MenuNavLink} to={RouteEnum.Branch} name="Branch" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={branchesImg} alt="" />
            {Label.Mainnav.Branch}
          </span>
        </NavLink>
        <NavLink as={MenuNavLink} to={RouteEnum.News} name="News" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={newsImg} alt="" />
            {Label.Mainnav.NewsEvents}
          </span>
        </NavLink>

        {/* <NavLink as={MenuNavLink} to={this.logoutPage} name="Logout" activeClassName={styles.active}> */}
        {/* <span className={styles.mainNavigation}>
              <img src={moreImg} alt="" />
              {Label.Mainnav.Logout}
            </span> */}
        <Link onClick={logoutPage}>
          <span className={styles.mainNavigation}>
            <img src={logout} alt="" />
            {Label.Mainnav.Logout}
          </span>
        </Link>
        {/* </NavLink> */}
        <NavLink as={MenuNavLink} to={RouteEnum.More} name="More" activeClassName={styles.active}>
          <span className={styles.mainNavigation}>
            <img src={moreImg} alt="" />
            {Label.Mainnav.More}
          </span>
        </NavLink>
      </div>
    </div>
  );
};

export default MainNav;
